'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'gauge-max';
var width = 512;
var height = 512;
var aliases = ["tachometer-alt-fastest"];
var unicode = 'f626';
var svgPathData = ['M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM64 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm48-112a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm80 208c0 35.3 28.7 64 64 64c17.7 0 33.7-7.2 45.3-18.7c5.8-5.8 10.5-12.7 13.7-20.3c1.6-3.8 2.9-7.8 3.7-12c.4-2.1 .8-4.2 1-6.4c.1-1.1 .2-2.2 .2-3.2c.1-1.1 .1-2.2 .1-3.3c0-.9 0-1.8-.1-2.7s-.1-1.8-.2-2.7c-.2-1.8-.4-3.6-.7-5.4c39.2-24.3 78.4-48.5 117.5-72.8c3.7-2.3 6.5-5.4 8.4-8.9c1-1.8 1.7-3.6 2.2-5.6c.2-1 .4-2 .6-2.9c.1-.5 .1-1 .1-1.5c0-.3 0-.5 0-1.5l-.1-1.7c0 0-.1-.8-.2-1.6c-.1-1.1-.4-2.1-.7-3.2c-.6-2.1-1.5-4.2-2.7-6.2c-7-11.3-21.8-14.8-33-7.8c-39.2 24.3-78.4 48.5-117.5 72.8C283.2 292.6 270.1 288 256 288c-35.3 0-64 28.7-64 64zM224 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm112 48a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z', 'M411.4 227.6c11.3-7 26.1-3.5 33 7.8s3.5 26.1-7.8 33L319.1 341.2c.6 3.5 .9 7.1 .9 10.8c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c14.1 0 27.2 4.6 37.8 12.4l117.5-72.8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGaugeMax = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;